export * from '@primeuix/themes/lara/menubar';
export { default } from '@primeuix/themes/lara/menubar';
